import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

// =========== Header START ===========
export const headerGSAP = (ref: any) => {
  const tl = gsap.timeline({
    defaults: { duration: 1.8, ease: "power2.out" },
  });

  tl.from(ref.current.querySelector("#header"), {
    y: -50,
    opacity: 0,
  });

  // gsap.to(ref.current.querySelector("#default_hlogo"), {
  //   y: -100,
  //   duration: 1,
  //   ease: "power2.out",
  //   scrollTrigger: {
  //     trigger: ".__StrategySection",
  //     start: "top center", // When top of .__StrategySection hits center of viewport
  //     toggleActions: "play none none none", // Play only once on scroll
  //     markers: true,
  //   },
  // });
};

export const headerLogoSwitcherDesktop = () => {
  const defaultLogo = ".default_hlogo";
  const scrolledLogo = ".scroll_hlogo";

  if (!defaultLogo || !scrolledLogo) return;

  gsap.set(scrolledLogo, { y: -50, opacity: 0 });

  ScrollTrigger.create({
    trigger: ".__bannerSection",
    start: "top -90%",
    onEnter: () => {
      gsap.to(defaultLogo, {
        y: -50,
        opacity: 0,
        duration: 0.5,
        ease: "power2.out",
      });
      gsap.to(scrolledLogo, {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
      });
    },
    onLeaveBack: () => {
      gsap.to(defaultLogo, {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
      });
      gsap.to(scrolledLogo, {
        y: -50,
        opacity: 0,
        duration: 0.5,
        ease: "power2.out",
      });
    },
    // markers: true,
  });
};

// header switcher for mobile
export const headerLogoSwitcherMobile = () => {
  const defaultLogo = ".default_hlogo";
  const scrolledLogo = ".scroll_hlogo";
  const headerSection = ".__headerSection";

  if (!defaultLogo || !scrolledLogo) return;

  gsap.set(scrolledLogo, { y: -50, opacity: 0 });

  ScrollTrigger.create({
    trigger: ".__bannerSection",
    start: "top -40%",
    onEnter: () => {
      gsap.to(defaultLogo, {
        y: -50,
        opacity: 0,
        duration: 0.5,
        ease: "power2.out",
      });
      gsap.to(scrolledLogo, {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
      });
      gsap.to(headerSection, {
        background: "#fff",
        boxShadow: "0 10px 20px rgba(1, 5, 97, 0.1)",
        duration: 0.5,
        ease: "power2.out",
      });
    },
    onLeaveBack: () => {
      gsap.to(defaultLogo, {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
      });
      gsap.to(scrolledLogo, {
        y: -50,
        opacity: 0,
        duration: 0.5,
        ease: "power2.out",
      });
      gsap.to(headerSection, {
        background: "",
        boxShadow: "",
        duration: 0.5,
        ease: "power2.out",
      });
    },
    // markers: true,
  });
};

// export const headerLogoSwitcherDesktop = () => {
//   const defaultLogo = ".default_hlogo";
//   const scrolledLogo = ".scroll_hlogo";

//   if (!defaultLogo || !scrolledLogo) return;

//   // Hide scrolled logo initially
//   gsap.set(scrolledLogo, { y: -50, opacity: 0 });

//   const tl = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".__bannerSection",
//       start: "top -90%",
//       end: "top -90%",
//       scrub: true,
//       markers: true,
//     },
//   });

//   tl.to(defaultLogo, {
//     y: -50,
//     opacity: 0,
//     duration: 0.5,
//     ease: "power2.out",
//   }).to(
//     scrolledLogo,
//     {
//       y: 0,
//       opacity: 1,
//       duration: 0.5,
//       ease: "power2.out",
//     },
//     "<"
//   );
// };
// =========== Header END ===========

// =========== Hero Panel START ===========
export const heroPanelGSAP = (ref: any) => {
  const tl = gsap.timeline({
    defaults: { duration: 1, ease: "power2.out" },
  });

  tl.from(ref.current.querySelector("#bannerText"), {
    opacity: 0,
    letterSpacing: "2em",
  });

  gsap.from(ref.current.querySelectorAll("#b_subheading"), {
    opacity: 0,
    y: 20,
    duration: 0.3,
    delay: 0.5,
    stagger: 0.3,
  });

  gsap.from(ref.current.querySelectorAll("#banner_mheading"), {
    opacity: 0,
    duration: 1,
    delay: 0.5,
    onStart: () => {
      const copyRightElement = ref.current.querySelector("#banner_mheading");
      if (!copyRightElement) return;

      const letters = copyRightElement.textContent
        ?.split("")
        .map((char: any, index: number) => {
          const classes = ["char"];
          if (index === 2) classes.push("xchar");
          return `<div class="${classes.join(
            " "
          )}" style="display:inline-block;">${
            char === " " ? "&nbsp;" : char
          }</div>`;
        })
        .join("");

      copyRightElement.innerHTML = letters;

      // Animate each letter
      gsap.from(copyRightElement.querySelectorAll(".char"), {
        opacity: 1,
        stagger: 0.1,
        duration: 0.8,
        scale: 0,
        transformOrigin: "bottom",
        transform: "rotateX(-32deg)",
        ease: "power3.out",
      });
    },
  });

  gsap.from(ref.current.querySelector("#scroll_icon .__arrowScroll"), {
    delay: 1,
    duration: 1,
    opacity: 0,
    y: -100,
  });

  gsap.from(ref.current.querySelector("#scroll_icon p"), {
    delay: 1,
    duration: 1,
    opacity: 0,
    y: 100,
  });
};
// =========== Hero Panel END ===========

// =========== Animated Star Start ===========

export const animatedStar = (ref: any) => {
  const el = ref.current.querySelector("#animatedStar");
  const container = ref.current;

  if (!el || !container) return;

  // Calculate the distance from element's top to the bottom of the container
  const containerHeight = container.offsetHeight;
  const elOffsetTop = el.offsetTop;
  const travelY = containerHeight - elOffsetTop - el.offsetHeight;

  gsap.to(el, {
    y: travelY,
    rotation: 360,
    duration: 1,
    delay: 1,
    stagger: 0.2,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ref.current,
      start: "top 10%",
      end: "bottom center",
      scrub: 1.5,
      // markers: true,
    },
  });
};

// =========== Animated Star START ===========

// =========== Shuffle Animation START ===========
export const shuffleLogos = (
  container: HTMLDivElement,
  onComplete?: () => void
) => {
  const allItems = container.querySelectorAll(".__singleLogoCol");
  const activeItems = container.querySelectorAll(".__singleLogoCol.active");

  const activeImages = Array.from(activeItems)
    .map((item) => item.querySelector("img"))
    .filter(Boolean) as HTMLImageElement[];

  // Animate current images out
  gsap.to(activeImages, {
    y: -150,
    opacity: 0,
    duration: 0.3,
    stagger: 0.1,
    onComplete: () => {
      // After animation, wait 1s before showing next
      setTimeout(() => {
        // Hide current
        activeItems.forEach((el) => {
          el.classList.remove("active");
          (el as HTMLElement).style.display = "none";
        });

        // Get next 6
        const remainingItems = Array.from(allItems).filter(
          (el) => !el.classList.contains("active")
        );
        const nextItems = remainingItems.slice(0, 6);

        nextItems.forEach((el) => {
          el.classList.add("active");
          (el as HTMLElement).style.display = "flex";
        });

        const nextImages = nextItems
          .map((item) => item.querySelector("img"))
          .filter(Boolean) as HTMLImageElement[];

        // Animate next images in
        gsap.fromTo(
          nextImages,
          { y: 150, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.3,
            stagger: 0.1,
            ease: "power2.out",
            onComplete,
          }
        );
      }, 0);
    },
  });
};

// =========== Shuffle Animation END ===========

// =========== Services START ===========
export const servicesGSAP = (ref: any) => {
  const tl = gsap.timeline({
    defaults: { duration: 1, ease: "power2.out" },
  });

  gsap.from(ref.current.querySelector("#s_sub_heading"), {
    opacity: 0,
    y: 20,
    duration: 0.3,
    delay: 0.5,
    stagger: 0.3,
    scrollTrigger: {
      trigger: ref.current,
      start: "top 60%",
      end: "top 70%",
      scrub: 1.5,
    },
  });

  gsap.from(ref.current.querySelector("#banner_mheading"), {
    onStart: () => {
      const copyRightElement = ref.current.querySelector("#banner_mheading");
      if (!copyRightElement) return;

      const letters = copyRightElement.textContent
        ?.split("")
        .map((char: any, index: number) => {
          const classes = ["char"];
          if (index === 5) classes.push("c_char");
          return `<div class="${classes.join(
            " "
          )}" style="display:inline-block;">${
            char === " " ? "&nbsp;" : char
          }</div>`;
        })
        .join("");

      copyRightElement.innerHTML = letters;

      // Animate each letter
      gsap.from(copyRightElement.querySelectorAll(".char"), {
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scale: 0,
        transformOrigin: "bottom",
        transform: "rotateX(-32deg)",
        ease: "power3.out",
        scrollTrigger: {
          trigger: ref.current,
          start: "top 50%",
          end: "top 40%",
          scrub: 2,
        },
      });
    },
  });

  gsap.from(ref.current.querySelectorAll(".services_star"), {
    rotation: 360,
    duration: 0.5,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ref.current,
      start: "top 80%",
      end: "bottom top",
      scrub: 1.5,
      // markers: true,
    },
  });
};

export const servicesPinGSAP = (ref: any) => {
  const mainCard = ref.current.querySelectorAll(".__serviceCard");
  const cards = ref.current.querySelectorAll(".__absCard");
  const stars = ref.current.querySelectorAll(".services_star");
  const blue_star = ref.current.querySelectorAll(".blue_star");
  const heading = ref.current.querySelectorAll(".scard_heading");
  const subHeading = ref.current.querySelectorAll(".__serviceDesc");
  const defaultBtn = ref.current.querySelectorAll(".s__btn");

  if (!cards.length || !stars.length) return;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ref.current,
      start: "top top",
      end: "+=2000", // adjust this as needed
      scrub: true,
      pin: true,
      // markers: true,
      // onLeave: () => {
      //   enableHoverEffects(); // enable hover AFTER scroll section completes
      // },
    },
  });

  // Animate stars: scale down AND clip-path
  tl.to(
    stars,
    {
      scale: 0.4,
      y: -50,
      ease: "power2.out",
      stagger: 0.05,
    },
    0 // start with timeline
  );
  tl.to(
    blue_star,
    {
      clipPath: "inset(0% 0% 0%)", // animate the bottom inward
      ease: "power2.out",
      scrollTrigger: {
        trigger: blue_star,
        start: "top 90%",
        end: "top 90%", // adjust this as needed
        // markers: true,
      },
    },
    0 // start with timeline
  );

  // Animate cards upward
  tl.to(
    cards,
    {
      y: "0%",
      opacity: 1,
      ease: "power2.out",
      stagger: 0.05,
    },
    0 // start at the same time
  );

  // Animate defaultBtn at the same time
  // tl.from(
  //   defaultBtn,
  //   {
  //     y: 100,
  //     // opacity: 0,
  //     duration: 0.5,
  //     ease: "power2.out",
  //   },
  //   0 // Also start at the beginning
  // );

  // heading animation
  tl.from(
    heading,
    {
      opacity: 0,
      y: 20,
      delay: 0.2,
      stagger: 0.3,
    },
    0
  );
  // Subheading animation
  tl.from(
    subHeading,
    {
      opacity: 0,
      y: 150,
      delay: 0.5,
      stagger: 0.3,
    },
    0.5
  );
};

// =========== Services END ===========

// =========== Case Study START ===========

export function animateTextChange({
  currentEl,
  nextEl,
  profitEl,
  currentData,
  nextData,
}: {
  currentEl: HTMLElement;
  nextEl: HTMLElement;
  profitEl: HTMLElement | null;
  currentData: any;
  nextData: any;
}) {
  const currentContent = currentEl.querySelector(
    ".cs_content_parent"
  ) as HTMLElement;
  const nextContent = nextEl.querySelector(".cs_content_parent") as HTMLElement;

  // Animate headings
  gsap.set(currentContent, {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  });

  gsap.set(nextContent, {
    position: "relative",
    top: 0,
    left: 0,
    zIndex: 2,
    opacity: 0,
    y: 50,
  });

  gsap.to(currentContent, {
    opacity: 0,
    y: -50,
    duration: 0.4,
    ease: "power2.inOut",
    onComplete: () => {
      gsap.set(currentContent, { clearProps: "all" });
    },
  });

  gsap.to(nextContent, {
    opacity: 1,
    y: 0,
    duration: 0.4,
    ease: "power2.inOut",
  });

  // Animate only text inside profit cards (not the whole card)
  if (profitEl) {
    const profitItems = profitEl.querySelectorAll(".__profitCard");

    const profitValues = profitEl.querySelectorAll(".__percProfit");
    const profitDescriptions = profitEl.querySelectorAll(".__shortDesc");

    // Fade out old texts
    gsap.to([profitValues, profitDescriptions], {
      opacity: 0,
      y: -10,
      duration: 0.2,
      ease: "power1.in",
      onComplete: () => {
        // Update content
        profitValues[0].textContent = nextData.profit;
        profitDescriptions[0].textContent = nextData.profitText;

        profitValues[1].textContent = nextData.wonRate;
        profitDescriptions[1].textContent = nextData.wonRateText;

        profitValues[2].textContent = nextData.years;
        profitDescriptions[2].textContent = nextData.yearsText;

        // Animate in new texts
        gsap.fromTo(
          [profitValues, profitDescriptions],
          { opacity: 0, y: 10 },
          {
            opacity: 1,
            y: 0,
            duration: 0.3,
            ease: "power1.out",
            stagger: 0.05,
          }
        );
      },
    });
  }
}

// =========== Case Study END ===========

// =========== Our Clients START ===========
export const clientsHeadingGSAP = (ref: any) => {
  const tl = gsap.timeline({
    defaults: { duration: 1, ease: "power2.out" },
  });

  gsap.from(ref.current.querySelector("#s_sub_heading"), {
    opacity: 0,
    y: 20,
    duration: 0.3,
    delay: 0.5,
    stagger: 0.3,
    scrollTrigger: {
      trigger: ref.current,
      start: "top 60%",
      end: "top 70%",
      scrub: 1.5,
    },
  });

  gsap.from(ref.current.querySelector("#banner_mheading"), {
    onStart: () => {
      const copyRightElement = ref.current.querySelector("#banner_mheading");
      if (!copyRightElement) return;

      const letters = copyRightElement.textContent
        ?.split("")
        .map((char: any, index: number) => {
          const classes = ["char"];
          if (index === 0) classes.push("c_char");
          return `<div class="${classes.join(
            " "
          )}" style="display:inline-block;">${
            char === " " ? "&nbsp;" : char
          }</div>`;
        })
        .join("");

      copyRightElement.innerHTML = letters;

      // Animate each letter
      gsap.from(copyRightElement.querySelectorAll(".char"), {
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scale: 0,
        transformOrigin: "bottom",
        transform: "rotateX(-32deg)",
        ease: "power3.out",
        scrollTrigger: {
          trigger: ref.current,
          start: "top 50%",
          end: "top 40%",
          scrub: 2,
        },
      });
    },
  });
};
export function animateReviewChange({
  imageRef,
  nameRef,
  designationRef,
  contentRef,
  direction,
  onComplete,
}: {
  imageRef: React.RefObject<HTMLImageElement>;
  nameRef: React.RefObject<HTMLDivElement>;
  designationRef: React.RefObject<HTMLDivElement>;
  contentRef: React.RefObject<HTMLDivElement>;
  direction: "next" | "prev";
  onComplete: () => void;
}) {
  const tl = gsap.timeline({
    onComplete,
  });

  const outX = direction === "next" ? -100 : 100;
  const inX = direction === "next" ? 100 : -100;

  tl.set(imageRef.current, { x: inX, opacity: 0 })
    .set([nameRef.current, designationRef.current, contentRef.current], {
      y: 50,
      opacity: 0,
    })
    .to(imageRef.current, {
      x: 0,
      opacity: 1,
      duration: 0.3,
      ease: "power2.out",
    })
    .to(
      [nameRef.current, designationRef.current, contentRef.current],
      {
        y: 0,
        opacity: 1,
        duration: 0.4,
        stagger: 0.1,
        ease: "power2.out",
      },
      "-=0.2"
    );
}

interface AnimateSideImageChangeParams {
  prevImageRef: HTMLImageElement | null;
  nextImageRef: HTMLImageElement | null;
  direction: "next" | "prev";
}

export const animateSideImageChange = ({
  prevImageRef,
  nextImageRef,
  direction,
}: AnimateSideImageChangeParams) => {
  const duration = 0.4;
  const ease = "power2.out";

  // star icon
  const starIcon = document.querySelector(".__reviewIcon .star");
  // lines
  const lines = document.querySelector(".__reviewIcon .lines");

  // Rotate the star icon based on direction
  if (starIcon) {
    gsap.fromTo(
      starIcon,
      { rotation: 200, opacity: 0.5 },
      {
        rotation: direction === "next" ? 360 : 0,
        opacity: 1,
        ease: "power2.inOut",
      }
    );
  }

  // lines icon based on direction
  if (lines) {
    gsap.fromTo(
      lines,
      { scale: 0, opacity: 0.5 },
      {
        scale: direction === "next" ? 1 : 1,
        opacity: 1,
        ease: "power2.inOut",
      }
    );
  }

  if (direction === "next") {
    // Animate next image from right to center
    if (nextImageRef) {
      gsap.fromTo(
        nextImageRef,
        { x: 150, opacity: 0 },
        { x: 0, opacity: 1, duration, ease }
      );
    }

    // Animate prev image out to left
    if (prevImageRef) {
      gsap.fromTo(
        prevImageRef,
        { x: 150, opacity: 0 },
        { x: 0, opacity: 1, duration, ease }
      );
    }
  } else {
    // Animate prev image from left to center
    if (prevImageRef) {
      gsap.fromTo(
        prevImageRef,
        { x: -150, opacity: 0 },
        { x: 0, opacity: 1, duration, ease }
      );
    }

    // Animate next image out to right
    if (nextImageRef) {
      gsap.fromTo(
        nextImageRef,
        { x: -150, opacity: 0 },
        { x: 0, opacity: 1, duration, ease }
      );
    }
  }
};

// =========== Our Clients END ===========
